module.exports = __webpack_public_path__ + "img/SolvasLogoShort.ef22e043.png";